import aedSvg from '@/assets/aed-symbol.svg';

interface AedSymbolProps {
  className?: string;
  size?: number;
}

const AedSymbol = ({ className = '', size = 14 }: AedSymbolProps) => (
  <img
    src={aedSvg}
    alt="AED"
    width={size}
    height={size}
    className={`inline-block align-middle ${className}`}
    style={{ verticalAlign: 'middle' }}
    draggable={false}
  />
);

export default AedSymbol;
